// extracted by mini-css-extract-plugin
export default {"video_briefs":"index_video_briefs_xW7lv","source":"index_source_FLXgJ","video":"index_video_GeZ07","videoBtn":"index_videoBtn_0FMMh"};